import Swiper from "swiper";
/**
 * Ir_faq
 * @constructor
 */
class Ir_faq {
  constructor() {}
  /**
   * コモン
   */
  init() {
    
    var pc = window.matchMedia("(min-width: 768px)").matches;
    var sp = window.matchMedia("(max-width: 767px)").matches;
    
    //ir faq　アコーディオン
    $('.js-faq-toggle').on('click', function () {
      $(this).toggleClass('is-active');
      $(this).next().stop().slideToggle();
    })
    
    
    
  }
}

export default Ir_faq;